export default {
  switchAccount: "Switch Account",
  login: "Log in",
  loginFirst: "Please log in",
  start: "Start",
  hasHistory: "You've already answered some of the questions.",
  loadHistory: "Would you like to continue?",
  cancel: "No",
  confirm: "Yes",
  contact: "Leave your contact details for a chance of winning bonus rewards!",
  completed: "You've completed the survey!",
  leaveMessage:
    "Leave your contact details for a chance of winning bonus rewards!",
  enterEmail: "E-mail: ",
  enterPhone: "Phone: ",
  submit: "Submit",
  leave: "Leave",
  submitted: "Submitted",
  thanks: "Thanks!",
  opinion: "Please specify",
  prev: "Previous",
  next: "Next",
  unlikely: "Very unlikely",
  likely: "Very likely",
  claimYourRewards: "You may claim your rewards.",
  rewardSent: "Rewards sent.",
  checkInGame: "Please claim them in the game.",
  copy: "Copy",
  copied: "Copied!",
  selectTips: "Please select the best answer.",
  multipleTips: "You may select multiple answers.",
  leastChoose: "Select up to xxx answers",
  maxChoose: "Select at least xxx answers.",
  mustAnswer: "Please answer the current question first.",
  mustWrite: "Please write something.",
  checkEmail: "Please enter a valid e-mail address.",
  checkPhone: "Please enter a valid phone number.",
  isAnswer: "You have answered the question.",
  unStart: "Event not available",
  end: "Event is over",
  server: "Select your server",
  role: "Select your character",
  common: "System is busy. Please retry later.",
  title: "Questionnaire",
  titleAward: "Survey",
  leastWord: "Please enter at least xxx characters.",
  maxWord: "Character limit (xxx) exceeded! ",
  singleChoose: "Single-Answer",
  multiChoose: "Multiple-Answer",
  matrix: "Matrix Question",
  score: "Rating",
  textLimit: "(xx-yyy characters)",
  coverGiftTitle: "Complete Survey to Claim Gift",
  "-20001": "Not logged in",
  "-20002": "Missing required parameters",
  "-20003": "Questionnaire not found",
  "-20004": "Questionnaire configuration in progress",
  "-20005": "Questionnaire stopped",
  "-20006": "Questionnaire event not started",
  "-20007": "Questionnaire event ended",
  "-20008": "Already answered",
  "-20010": "Reward distribution failed",
  "-20011": "Reward already distributed for this questionnaire",
  "-20012": "Not answered yet",
  "-20016": "Invalid game ID",
};
